export default "__VITE_ASSET__CSF3aFNt__"